var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      {
        staticClass: "container",
        staticStyle: {
          "padding-top": "20px",
          "padding-left": "20px",
          width: "auto",
        },
      },
      [
        _c("h1", { staticClass: "title" }, [_vm._v("常见问题")]),
        _vm._v(" "),
        _c("ul", { staticClass: "accordion" }, [
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("免费试用时长\n                    "),
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("找回密码或注册邮箱丢失"),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [_c("span", { staticClass: "accIcon" }), _vm._v("同时使用")]
            ),
            _vm._v(" "),
            _vm._m(2),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("背景音乐等的所有音效没声音"),
              ]
            ),
            _vm._v(" "),
            _vm._m(3),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("识别不出孩子说话"),
              ]
            ),
            _vm._v(" "),
            _vm._m(4),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("运行慢，有时会卡顿"),
              ]
            ),
            _vm._v(" "),
            _vm._m(5),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("应用一直闪退或不能启动"),
              ]
            ),
            _vm._v(" "),
            _vm._m(6),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("付款了但显示没有购买"),
              ]
            ),
            _vm._v(" "),
            _vm._m(7),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [_c("span", { staticClass: "accIcon" }), _vm._v("无法退出")]
            ),
            _vm._v(" "),
            _vm._m(8),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [_c("span", { staticClass: "accIcon" }), _vm._v("如何退款")]
            ),
            _vm._v(" "),
            _vm._m(9),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [_c("span", { staticClass: "accIcon" }), _vm._v("Android版本")]
            ),
            _vm._v(" "),
            _vm._m(10),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [_c("span", { staticClass: "accIcon" }), _vm._v("存档如何同步")]
            ),
            _vm._v(" "),
            _vm._m(11),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "item" }, [
            _c(
              "h2",
              {
                staticClass: "accordionTitle",
                on: { click: _vm.handleClickTitle },
              },
              [
                _c("span", { staticClass: "accIcon" }),
                _vm._v("想了解服务条款和隐私政策"),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("p", [
                _vm._v(
                  "\n                            都都英语的服务条款和隐私政策描述了美国Enuma总部的规则，职责和原则。"
                ),
                _c("br"),
                _vm._v(
                  "\n                            需要您同意才能注册使用都都英语的内容。 请在以下链接中查看更多详细信息，感谢！"
                ),
                _c("br"),
                _vm._v("\n                            1）服务条款>> "),
                _c(
                  "span",
                  {
                    staticClass: "link",
                    on: {
                      click: function ($event) {
                        return _vm.handleClickLink("tos")
                      },
                    },
                  },
                  [_vm._v("http://enuma.com/tos/")]
                ),
                _c("br"),
                _vm._v(
                  "\n                            2）收集和使用个人信息（隐私政策）>> "
                ),
                _c(
                  "span",
                  {
                    staticClass: "link",
                    on: {
                      click: function ($event) {
                        return _vm.handleClickLink("policy")
                      },
                    },
                  },
                  [_vm._v("http://enuma.com/policy/")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v("都都英语，年卡销售活动火热进行中，"),
        _c("br"),
        _vm._v("\n                        新用户注册即可获得7天免费体验机会。"),
        _c("br"),
        _vm._v(
          "\n                        7天免费体验时间从注册后启动应用开始起算。"
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("免费体验期间内可享受：")]),
        _c("br"),
        _vm._v(
          "\n                        1. 通过水平测试或自选方式设置课程水平"
        ),
        _c("br"),
        _vm._v("\n                        2. 所有内容无限制使用"),
        _c("br"),
        _vm._v("\n                        3. 支持多台设备同时使用"),
        _c("br"),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("免费体验Tip：")]),
        _c("br"),
        _vm._v(
          "\n                        1. 使用都都数学的账号可直接登录都都英语"
        ),
        _c("br"),
        _vm._v(
          "\n                        2. 免费体验过期，也不会自动扣款或自动延期订阅，请放心使用"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _c("strong", [_vm._v("如果您忘记了密码：")]),
        _c("br"),
        _vm._v(
          "\n                            1.您可以在登陆时点击忘记密码，然后去邮箱查收重置密码邮件，按照提示操作即可"
        ),
        _c("br"),
        _vm._v(
          "\n                            2.您也可以直接联系官方客服QQ:2179916770"
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("如果您忘记了注册邮箱:")]),
        _c("br"),
        _vm._v(
          "\n                            请直接联系官方客服QQ:2179916770\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v("\n                            1个账号可以添加1个孩子的存档。"),
        _c("br"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            都都英语有很丰富多样的各种音效，"
        ),
        _c("br"),
        _vm._v(
          "\n                            如果其中声音听不到， 您可以试试以下几种方式进行确认；"
        ),
        _c("br"),
        _c("br"),
        _vm._v("\n\n                            1. 检查设备是否设置为静音模式"),
        _c("br"),
        _vm._v("\n                            2. 调整设备音量"),
        _c("br"),
        _vm._v(
          "\n                            3. 都都英语支持音效关闭功能， 请在家长页面确认音效是否打开\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            请先由家长试试，如果还不能识别， 检查都都数学应用中的麦克风功能是否开启，"
        ),
        _c("br"),
        _vm._v(
          "\n                            请参考以下方式确认麦克风功能是否已开启；"
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("1. iOS机型：")]),
        _c("br"),
        _vm._v(
          "\n                            打开手机上的“设置”， 往下拉在“已安装应用列表”中找出“都都英语”，允许麦克风功能使用"
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("2. Android机型 ：")]),
        _c("br"),
        _vm._v(
          "\n                            打开手机上的“设置”> “应用” > “应用管理”， 其中找到“都都英语”， 请允许麦克风功能权限\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v("\n                            如果之前能够正常使用， "),
        _c("br"),
        _vm._v(
          "\n                            但突然开始有卡顿现象，可以试试关闭机器的电源并重启。"
        ),
        _c("br"),
        _vm._v(" "),
        _c("strong", [
          _vm._v("重启完后还反复出现同样问题， 请确认机器中的内存是否足够："),
        ]),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("1. iOS机型：")]),
        _c("br"),
        _vm._v(
          "\n                            打开“设置”> “通用” > “储存空间”， 剩余空间500M以上才能保证正常运行"
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("2. Android机型：")]),
        _c("br"),
        _vm._v(
          "\n                            打开“设置”> “手机信息” > “储存空间”， 剩余空间500M以上才能保证正常运行\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            应用不能正常使用有多种原因，其中三大类原因如下："
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("1. 软件版本过低")]),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("> iOS机型 ：")]),
        _c("br"),
        _vm._v(
          "\n                            打开“设置”> “关于本机”> 确认软件版本是否最新， 如果有更新提示，请进行更新，"
        ),
        _c("br"),
        _vm._v("\n                            详细内容请查看："),
        _c(
          "a",
          {
            attrs: {
              href: "https://support.apple.com/zh-cn/ios/update",
              target: "_blank",
            },
          },
          [_vm._v("https://support.apple.com/zh-cn/ios/update")]
        ),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("> Android机型 ：")]),
        _c("br"),
        _vm._v(
          "\n                            打开设置>关于手机> 软件手动更新， 可查看软件版本信息，如果有更新提示，请进行更新，"
        ),
        _c("br"),
        _vm._v("\n                            详细内容请查看："),
        _c(
          "a",
          {
            attrs: {
              href: "https://support.google.com/android/answer/7680439",
              target: "_blank",
            },
          },
          [_vm._v("https://support.google.com/android/answer/7680439")]
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("2. 都都英语版本过低")]),
        _c("br"),
        _vm._v(
          "\n                            请在应用商店中找出都都英语， 如果有更新提示，请进行更新"
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("3. 机器临时不正常运行")]),
        _c("br"),
        _vm._v("\n                            请关机，重启后尝试"),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n                            如果以上解答解决不了您的问题，请联系官方客服QQ:2179916770\n\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            请确认是否以付款时登陆的账号在登录， 我们支持邮箱登录和Apple账号登录， "
        ),
        _c("br"),
        _vm._v(
          "\n                            如果想不起来当时的登录账号请联系官方客服QQ:2179916770"
        ),
        _c("br"),
        _vm._v(
          "\n                            如果以Apple账号登录， 有时候会被切换成另一个账号， 这种情况也请联系客服，谢谢\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            如果使用Apple账号登录了， 于应用中无法退出，需要在Apple设置中进行退出："
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n                            打开Apple设备中的“设置”>选择Apple账号>密码与安全性>使用您Apple ID的App> 找到都都英语进行退出\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            根据Apple的政策，退款请联系Apple客服电话: 400-666-8800\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            您可以在中国大陆下载Android版本。"
        ),
        _c("br"),
        _vm._v(
          "\n                            请在小米，华为、OPPO、VIVO、联想、应用宝应用商店，搜索“都都英语”下载使用。\n                        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _vm._v(
          "\n                            请使用同一个邮箱的都都英语账号登陆在不同的设备，存档会自动同步\n                        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }